import { useEffect, useRef } from "react";

const promises = [
  {
    label: "Over 6 years' legacy of care",
    icon: require("../../assets/35-years.svg"),
    color: "from-teal-500 to-teal-600",
    bg: "bg-teal-500",
    desc: "Years of trusted service in your community",
  },
  {
    label: "Trained & Caring Pharmacist",
    icon: require("../../assets/Trained & Caring Pharmacist.svg"),
    color: "from-blue-500 to-blue-600",
    bg: "bg-blue-500",
    desc: "Expert pharmacists who genuinely care about you",
  },
  {
    label: "Genuine Medicines",
    icon: require("../../assets/Genuine Medicines.svg"),
    color: "from-teal-500 to-teal-600",
    bg: "bg-teal-500",
    desc: "100% authentic medicines from licensed suppliers",
  },
  {
    label: "Exhaustive Range of Products",
    icon: require("../../assets/Exhaustive Range of Products.svg"),
    color: "from-blue-500 to-blue-600",
    bg: "bg-blue-500",
    desc: "Comprehensive selection to meet all your healthcare needs",
  },
  {
    label: "Medicine Refill Reminders",
    icon: require("../../assets/Medicine Refill Reminders.svg"),
    color: "from-teal-500 to-teal-600",
    bg: "bg-teal-500",
    desc: "Never miss a dose with our reminder service",
  },
  {
    label: "Free Home Delivery",
    icon: require("../../assets/Free Home Delivery.svg"),
    color: "from-blue-500 to-blue-600",
    bg: "bg-blue-500",
    desc: "Get your medicines delivered right to your door",
  },
];

export default function Promise() {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.1 }
    );
    const items = ref.current?.querySelectorAll(".animate-on-view");
    items?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="promise" data-testid="promise-section" className="ez-section bg-ez-blue-light" ref={ref}>
      <div className="ez-container">
        {/* Header */}
        <div className="animate-on-view text-center mb-16">
          <div className="inline-block text-ez-teal font-semibold font-caveat text-lg mb-3">
            Our Commitment
          </div>
          <h2 className="font-outfit text-2xl md:text-3xl font-bold text-ez-text">
            We Promise <span className="text-ez-teal">You</span>
          </h2>
          <p className="text-ez-muted mt-4 max-w-xl mx-auto font-jakarta">
            Every visit to EZ Care Pharmacy comes with our unwavering promise of quality, care, and service.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {promises.map((item, i) => (
            <div
              key={item.label}
              data-testid={`promise-card-${i}`}
              className="animate-on-view ez-card p-8 flex flex-col items-start gap-4 group"
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className={`w-16 h-16 rounded-2xl ${item.bg} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                <img
                  src={item.icon.default || item.icon}
                  alt={item.label}
                  className="w-9 h-9"
                />
              </div>
              <div>
                <h3 className="font-outfit font-bold text-ez-text text-lg mb-1">
                  {item.label}
                </h3>
                <p className="text-ez-muted text-sm font-jakarta leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
